
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_ohtdp_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_ohtdp_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_ohtdp_119",
  "icon": "awsui_icon_gwq0h_ohtdp_133",
  "root": "awsui_root_gwq0h_ohtdp_151",
  "expand-button": "awsui_expand-button_gwq0h_ohtdp_168",
  "expanded": "awsui_expanded_gwq0h_ohtdp_175",
  "icon-container": "awsui_icon-container_gwq0h_ohtdp_179",
  "icon-container-container": "awsui_icon-container-container_gwq0h_ohtdp_184",
  "wrapper": "awsui_wrapper_gwq0h_ohtdp_188",
  "wrapper-default": "awsui_wrapper-default_gwq0h_ohtdp_196",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_ohtdp_199",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_ohtdp_205",
  "wrapper-container": "awsui_wrapper-container_gwq0h_ohtdp_219",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_ohtdp_225",
  "header": "awsui_header_gwq0h_ohtdp_229",
  "header-wrapper": "awsui_header-wrapper_gwq0h_ohtdp_232",
  "header-button": "awsui_header-button_gwq0h_ohtdp_239",
  "header-container-button": "awsui_header-container-button_gwq0h_ohtdp_243",
  "with-interactive-elements": "awsui_with-interactive-elements_gwq0h_ohtdp_261",
  "header-container": "awsui_header-container_gwq0h_ohtdp_243",
  "header-navigation": "awsui_header-navigation_gwq0h_ohtdp_273",
  "content": "awsui_content_gwq0h_ohtdp_97",
  "content-default": "awsui_content-default_gwq0h_ohtdp_309",
  "content-footer": "awsui_content-footer_gwq0h_ohtdp_312",
  "content-expanded": "awsui_content-expanded_gwq0h_ohtdp_315",
  "focusable": "awsui_focusable_gwq0h_ohtdp_319"
};
  